import { Container } from 'react-dom';
import { Layout } from 'antd';
import type { ReactElement } from 'react';
import type { ContainerProps } from './types';

export function Container({ children }: ContainerProps): ReactElement {
  return <Layout style={{ marginLeft: '6px', marginRight: '6px' }}>{children}</Layout>;
}
